import React from 'react';
import PropTypes from 'prop-types';

import './max-width.css';

const MaxWidth = ({ children, className }) => (
  <div className={`max-width ${className}`}>{children}</div>
);

MaxWidth.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

MaxWidth.defaultProps = {
  className: '',
};

export default MaxWidth;



// WEBPACK FOOTER //
// ./src/components/max-width/index.js